export enum MfaSortingProperties {
    NAME = 'name',
    EMAIL = 'email',
    ENABLED_AT = 'enabledAt',
    STATUS = 'status',
}
